import { AuthService } from './../core/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { Item } from '../models/item';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-brand-audit-view',
  templateUrl: './brand-audit-view.component.html',
  styleUrls: ['./brand-audit-view.component.css']
})
export class BrandAuditViewComponent implements OnInit {
  surveyCollection: AngularFirestoreCollection<Item>;
  surveys: Observable<Item[]>;
  surveyList: any;
  surveyData: any;
  showSpinner: boolean = true;
  id: number;
  private sub: any;
  doc_id: any;
  nowDate: any;
 
  readonly path = 'brandAudit';
 
  requestDocs: Observable<Item[]>;
 
  constructor(private route: ActivatedRoute,private router: Router, private fb: FormBuilder, private afs: AngularFirestore, private authService: AuthService ) {
 
  }
 

  getList(): Observable<Item[]>{
    return this.afs.collection<Item>(this.path, ref => ref.where('request_id', '==' , this.doc_id))
    .snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Item;
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });
  }

 
  ngOnInit() {
    this.route.params.subscribe(res => this.doc_id = res.id)
    this.requestDocs = this.getList();
  }
 

   
}


// WEBPACK FOOTER //
// ./src/app/brand-audit-view/brand-audit-view.component.ts